import { useAuth } from '../AuthContext';
import { useCompanySettings } from '../CompanySettingsContext';
import { canViewPrices, DEFAULT_PRICE_VISIBLE_FIELD_ROLES } from '../utils/job/jobRecordAccess';

/**
 * RD-ROLE-005 — the ONE client answer to "may this session see prices?".
 * While CompanySettingsContext is still loading, the DB default applies
 * (worker blind, supervisor visible), so nothing flashes a dollar at a worker.
 * @returns {{ canSeePrices: boolean, resolved: boolean }}
 */
export function usePriceVisibility() {
  const { role } = useAuth();
  const { priceVisibleFieldRoles, loading } = useCompanySettings();
  const roles = !loading && Array.isArray(priceVisibleFieldRoles)
    ? priceVisibleFieldRoles
    : DEFAULT_PRICE_VISIBLE_FIELD_ROLES;
  // `role` rides along so a caller can tell a blind FIELD role (worker/
  // supervisor) from money-blind operations without a second useAuth().
  return { canSeePrices: canViewPrices(role, roles), resolved: !loading, role };
}
